import * as z from 'zod'

const dispositivos = ['ios', 'web', 'android'] as const
export const DispositivoZod = z.enum(dispositivos)
export type Dispositivo = z.infer<typeof DispositivoZod>

export const ModoZod = z.enum(['dev', 'debug', 'staging', 'produccion', 'tunel'])
export type Modo = z.infer<typeof ModoZod>
